<template>
  <div class="application-tips" :style="field.style || ''">{{field.label}}</div>
</template>

<script>

export default {
  name: 'application-subtitle',
  props: {
    field: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
@import  '../../../assets/less/variable';
.application-tips {
  border-top: 1px solid @border;
  color: @text-6f;
  font-size: 14px;
  padding: 12px 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-tips.vue